import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, Button } from '@mui/material';
import ChiefObjective from './ChiefObjective';

const CompanyHeader = ({ company, isUnassigned = false, searchQuery, onOpenExternalEffortModal, onViewAsExpert, onGenerateReport }) => {
  const searchHighlight =
    searchQuery && company.toLowerCase().includes(searchQuery.toLowerCase()) ? { flex: 1, backgroundColor: 'rgba(255, 255, 0, 0.2)' } : { flex: 1 };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
      <Typography variant="h5" sx={searchHighlight}>
        {company}
      </Typography>
      {!isUnassigned && (
        <>
          <ChiefObjective variant="compact" company={company.toLowerCase().replace(/\s+/g, '').replace(/-/g, '')} />
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Button variant="outlined" color="primary" onClick={() => onOpenExternalEffortModal?.(company)}>
                Add additional effort
              </Button>
              <Button variant="outlined" color="primary" onClick={() => onViewAsExpert?.(company)}>
                Preview as expert
              </Button>
              <Button variant="contained" color="primary" onClick={() => onGenerateReport?.(company)}>
                Generate & send report
              </Button>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

CompanyHeader.propTypes = {
  company: PropTypes.string.isRequired,
  isUnassigned: PropTypes.bool,
  searchQuery: PropTypes.string,
  onOpenExternalEffortModal: PropTypes.func,
  onViewAsExpert: PropTypes.func,
  onGenerateReport: PropTypes.func,
};

export default CompanyHeader;
